import React from 'react';
import Select from 'react-select';
import {getAllUsers, getUsers} from '../../containers/Layouts/Admin/Dentists/actions';
import { connect } from "react-redux";

class CustomModalBody extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            first_name: true,
            last_name: true,
            isTextareaFocused: false,
        }
    }

    componentDidMount() {
        if (this.props.createdByAdmin) {
            this.props.getAllDentists();
        }
    }

    render() {
        return (
            <form className="patients-modal">
                {(this.props.createdByAdmin && !this.props.disableSelectDentist) ?
                    <div className={(this.props.validation.dentist_id === true) ? "patients-modal__select" : "patients-modal__select has-error"}>
                        <label className="text-field__label" htmlFor="select_dentist">Dentist</label>
                        <Select name="dentists"
                                id="select_dentist"
                               placeholder="Select a dentist"
                               style={{
                                   boxShadow: 'none'
                               }}
                               value={ this.props.selectedDentist }
                               onChange={ (selectedOption) => this.props.handleChangeDentist(selectedOption) }
                               options={ this.props.dentists.loading ? [{ label: 'Loading...', className: 'custom-class-select', disabled: true }] : this.props.dentists.allDentistsList.map((dentist, index) => ({value: dentist.id, label: dentist.first_name+' '+dentist.last_name, className: 'custom-class-select'})) }
                        />
                        <span className="error-message">Dentist name is required.</span>
                    </div> : ''
                }
                <div className="patients-modal__name">
                    <div
                        className={(this.props.validation.first_name) ? "text-field" : "text-field has-error"}
                    >
                        <label className="text-field__label" htmlFor="new-patient-first-name">First Name</label>
                        <input
                            className="text-field__input"
                            id="new-patient-first-name"
                            value={this.props.editPatientInfo && this.props.editPatientInfo.first_name}
                            type="text"
                            onChange={(e) => this.props.handelChange('first_name', e.target.value)}
                            placeholder="First Name"
                        />
                        {this.props.validation.first_name === false && <span className="error-message">First name is required.</span>}
                    </div>
                    <div
                        className={(this.props.validation.last_name) ? "text-field" : "text-field has-error"}
                    >
                        <label className="text-field__label" htmlFor="new-patient-last-name">Last Name</label>
                        <input
                            className="text-field__input"
                            id="new-patient-last-name"
                            value={this.props.editPatientInfo && this.props.editPatientInfo.last_name}
                            type="text"
                            onChange={(e) => this.props.handelChange('last_name', e.target.value)}
                            placeholder="Last Name"
                        />
                        {this.props.validation.last_name === false && <span className="error-message">Last name is required.</span>}
                    </div>
                </div>
                <div
                    className="text-field textarea"
                >
                    <label className="text-field__label" htmlFor="new-patient-notes">Information about the
                        Patient</label>
                    <div
                        className={`textarea__block ${this.state.isTextareaFocused ? 'textarea__block--focused' : ''}`}>
                        <textarea
                            maxLength={60}
                            className="text-field__input"
                            id="new-patient-notes"
                            onFocus={() => this.setState({isTextareaFocused: true})}
                            onBlur={() => this.setState({isTextareaFocused: false})}
                            placeholder="DO NOT ADD CASE INFORMATION HERE"
                            value={this.props.editPatientInfo && this.props.editPatientInfo.notes}
                            onChange={(e) => this.props.handelChange('notes', e.target.value)}
                        />
                    </div>
                </div>
            </form>
        );
    }
}


const mapStateToProps = state => ({
    dentists: state.dentists,
    allDentists: state.dentists.allDentistsList
});

const mapDispatchToProps = dispatch => {
    return {
        getAllDentists: () => dispatch(getAllUsers()),
        getUsers: () => dispatch(getUsers())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomModalBody);



// WEBPACK FOOTER //
// ./src/components/Patient/CustomModalBody.js